import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { ElectronicSignatureDto } from '@/modules/common/dto/electronic-signature.dto.ts';
import type {
  ElectronicSignatureRow,
  ElectronicSignaturesTable,
} from '@/modules/document/adapters/electronic-signature.type.ts';

function isSigned(item: ElectronicSignatureDto): boolean {
  const value = item.ЭП ?? item.ЭЦП ?? 0;
  return value > 0;
}

export class ElectronicSignatureAdapter {
  static mapList(response: ItemsDto<ElectronicSignatureDto>): ElectronicSignaturesTable {
    const roles: string[] = [];
    const rolesSet = new Set<string>();
    const rowsByFileId = new Map<number | null, ElectronicSignatureRow>();
    const rows: ElectronicSignatureRow[] = [];

    for (const item of response.items) {
      const role = item.Пользователь;

      if (role && !rolesSet.has(role)) {
        rolesSet.add(role);
        roles.push(role);
      }

      const fileId = item.F_ID;
      let row = rowsByFileId.get(fileId);

      if (!row) {
        row = {
          F_ID: fileId,
          Номер: item.Номер,
          Файл: item.Файл,
          Редакция: item.Редакция,
          signs: {},
        };
        rowsByFileId.set(fileId, row);
        rows.push(row);
      }

      if (role) {
        row.signs[role] = isSigned(item);
      }
    }

    return { roles, rows };
  }
}
